import { RESOURCE_TYPE } from '../../utils/constants';

// AUTH ENDPOINTS
export const login = '/auth/login';
export const resetPassword = '/auth/reset-password';

//USER MGMT ENDPOINTS
export const getUserInfo = '/user/me';
export const getFollowedProjectsCount = '/project/v2/following-count';
export const acceptSuperPollutantsTerms = '/user/super-pollutants-terms/accept';

// EMAIL VERIFICATION ENDPOINTS
export const sendVerificationOtp = '/user/otp/send';
export const resendVerificationOtp = '/user/otp/resend';
export const verifyEmailOtp = '/user/otp/verify';

//DASHBOARD ENDPOINTS
export const dashboardProjects = '/project/v2/dashboard';
export const dashboardGraph = '/project/v2/dashboard-graph';

//ASSETS
export const assetBaseUrl = process.env.ASSET_BASE_URL;
export const assetBaseUrl2 = process.env.ASSET_BASE_URL2;
export const getVendorLogoURL = (slug: string) =>
  `${assetBaseUrl}/public/img/vendor_logos/${encodeURIComponent(slug)}`;

export const getAssetURL = (slug: string, type?: string) => {
  if (type === RESOURCE_TYPE) {
    return `${assetBaseUrl}/assets/files/resources/${encodeURIComponent(decodeURIComponent(slug))}`;
  } else {
    return `${assetBaseUrl}/assets/images/blog/${encodeURIComponent(decodeURIComponent(slug))}`;
  }
};

export const getRatingUrl = (slug: string) => {
  return `${assetBaseUrl}/public/img/rating/${slug}`;
};

export const getSdgTargetUrl = (slug: string) => {
  return `${assetBaseUrl}/public/img/sdg/sdg_target_${slug}.svg`;
};

//SEARCH PAGE ENDPOINTS
export const searchProjects = 'project/v2/search';
export const searchFilters = 'project/v2/search_filter_metadata';
export const searchPageCharts = 'project/v2/stats';

//PROJECT DETAIL
export const projectDetails = '/project/v2/detail';
export const projectSdgData = '/project/v2/sdg-rating-data';
export const relatedContent = '/project/related-content';
export const projectFollow = '/project/v2/follow';
export const projectUnfollow = '/project/v2/unfollow';
export const projectCreditSummary = '/project/annual-credit-summary';
export const requestEsrScreening = '/esr/v2/report-request-form';

//WHERE TO BUY PAGE ENDPOINTS
export const whereToBuy = '/wheretobuy/all';
export const registerInterestRequest = '/pricing/v2/contact-vendor';

// RESOURCE PAGE ENDPOINTS
//PROJECT PAGE ENDPOINTS
export const projectGHGRatingData = '/project/ghg-rating-data';
export const resources = '/resource';

//RETIREE INSIGHTS ENDPOINTS
export const allRetireeInsights = '/retireeinsights/all';
export const filterMetadata = '/retireeinsights/filters_metadata';
export const projectRetireeInsights = '/retireeinsights/top_retirees';
export const projectRetireeTable = '/retireeinsights/project_table';
export const retireeAggregateData = '/retireeinsights/aggregate_stats';
export const retireeMarketShareData = '/retireeinsights/market_share';
export const retireeProjectPortfolio = '/retireeinsights/portfolio';
export const retireeBreakdownPieChart = '/retireeinsights/breakdown_stats';
export const retireeBreakdownTimeseriesChart = '/retireeinsights/breakdown_stats_timeseries';

//PROJECT ENDPOINTS
export const projectTypes = '/project_types';

//CONTACT PAGE ENDPOINTS
export const contact = '/user/contact-us';

//esr
export const esrSummary = '/esr/v2/summary';
export const esrDetailSummary = '/esr/v2/detailed-summary';
export const esrProjectComparison = '/esr/v2/project-comparison';

//ACCOUNT REQUEST ENDPOINTS
export const accountRequest = '/user/account-request';
export const projectNames = '/project/names';
export const getProjectCreditAvailability = (projectId: string) =>
  `/project/${projectId}/credits-data`;

//PUBLIC REGISTER ENDPOINTS
export const validatePublicEmail = '/user/validate-email/public';
export const signupPublic = '/user/signup/public';
export const resetPasswordPublic = '/user/resend-email/public';
export const getCompanyTypes = '/user/company-types/public';
//SELLER INVENTORY ENDPOINTS
export const buyCreditsForm = '/pricing/v2/form/buy-credits';
export const sellCreditsForm = '/pricing/v2/form/sell-credits';
export const getProjectSellerOffersEndpoint = (projectId: string, ghgStandardCode: string) =>
  `/pricing/v2/inventory?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}`;

export const getSellerOffersSummary = (projectId: string, ghgStandardCode: string) =>
  `/pricing/v2/summary?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}`;

// PRICING AND SUPPLY ENDPOINTS
export const getPriceRangeDataByVintage = (projectId: string, ghgStandardCode: string) =>
  `/pricing/v2/by-vintage?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}`;
export const getTradePriceDistribution = (
  projectId: string,
  ghgStandardCode: string,
  type: 'this_project' | 'all_project' = 'this_project'
) =>
  `/pricing/v2/distribution?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}&type=${type}`;
export const getEstimatedTradePrice = (projectId: string, ghgStandardCode: string) =>
  `/pricing/v2/estimated-trade-price?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}`;
export const getPricingSummary = (projectId: string, ghgStandardCode: string) =>
  `/pricing/v2/summary?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}`;

// RATING COMPARISON ENDPOINT
export const getRatingComparison = (
  projectId: string,
  ghgStandardCode: string,
  filter: 'this_project' | 'all_project' = 'this_project'
) =>
  `/project/v2/rating-comparison?project_id=${encodeURIComponent(projectId)}&ghg_standard_code=${encodeURIComponent(ghgStandardCode)}&filter=${filter}`;

//INSIGHTS HUB ENDPOINTS
export const pinnedPostAggregateData = 'project/v2/insights-hub-pinned-post-data';

// DEVELOPER PORTAL ENDPOINTS
export const ratingSummaryRequestForm = 'project/rating-summary-request-form';
export const ratingNotificationRequestForm = 'project/rating-notification-request-form';

// COMPASS ENDPOINTS
export const ratingDistribution = '/project/compass/overview/rating-graph';
export const compassUpdates = '/compass/updates/list';
export const methodologyRiskGraph = '/project/compass/methodologies/risk-graph';
export const compass = '/compass';

// SUPPLY LINK ENDPOINTS
export const supplyLinkList = '/project/v2/supply-link/list';
export const supplyLinkFilterMeta = '/project/v2/supply-link/filter-metadata';
export const submitSupplyRequest = '/project/v2/forms/supply-request';
export const submitRequestForm = '/project/submit-request-form';

// EXPERT ADVISORY ENDPOINTS
// Our branch migrated to v2 in 509f0be2; keep the v2 path and combine with
// main's new PROJECT SCREENER block.
export const advisoryForm = '/pricing/v2/form/advisory';

// PROJECT SCREENER (PDD ANALYZER) ENDPOINTS
// Spec: https://calyxglobal.atlassian.net/wiki/spaces/E/pages/56164353
export const screeningAll = '/project/screening/all';
export const screeningIncomplete = '/project/screening/incomplete';
export const screeningUpload = '/project/screening/upload';
export const screeningCreate = '/project/screening/create';
export const screeningEvents = (screeningId: string) => `/project/screening/${screeningId}/events`;
export const screeningDetails = (screeningId: string) =>
  `/project/screening/${screeningId}/details`;
export const screeningCancel = (screeningId: string) => `/project/screening/${screeningId}/cancel`;
export const screeningReport = (screeningId: string) => `/project/screening/${screeningId}/report`;
export const screeningInterestFormSubmit = '/project/screening/form-submit';
// Not in the main-flow spec (open question on credits) — keeping path consistent
// with the rest of the screener endpoints; flip if BE picks a different one.
export const screeningCredits = '/project/screening/credits';
export const coveredMethodologiesList = '/ghg_methodologies/screener/list';

// MY PLAN
// Counters + period dates land on the existing `/user/me` payload under
// `benefits`. Advisory-requests + inquiry surfaces persist customer-side
// form submissions so AMs see them in the admin Pending Inquiries panel.
export const myPlanDeepDiveRedeem = '/user/me/deep-dive/redeem';
export const myPlanSeats = '/user/me/seats';
// Single endpoint for every customer form (Use-a-Fastpass, Get-a-Quote both
// variants, Request-a-call). Server writes customer_inquiry + forwards to
// the matching Hubspot form per `source`.
export const myPlanInquiries = '/user/me/inquiries';
// Canonical advisory log (replaces deep-dive/requests for new surfaces):
// supports mode=dashboard (5-cap) + mode=full + filters (type, status, search).
export const myPlanAdvisoryRequests = '/user/me/advisory-requests';
export const myPlanAdvisoryReport = (id: string) => `/user/me/advisory-requests/${id}/report`;

// RATINGS QUEUE
// Reads + votes live in the search subsystem (project/v2/queue -> {message,result}
// envelope, unwrap res.data.result). Fastpass self-redeem lives in the myplan
// subsystem (/user/me/ratings-queue/:id/fastpass -> {message,data}).
export const ratingsQueue = 'project/v2/queue';
export const ratingsQueueVote = (id: string) => `project/v2/queue/${id}/vote`;
// Per-project vote tally + this user's vote state ({message,data} envelope,
// unwrap res.data.data). Used by the exec-summary request-a-rating modal, which
// has no queue row to source the count from.
export const ratingsQueueVoteStatus = (id: string) => `project/v2/queue/${id}/vote-status`;
export const ratingsQueueFastpass = (id: string) => `/user/me/ratings-queue/${id}/fastpass`;
